export default function MessageError({ error, className }) {
	if (typeof error !== 'string') {
		return null;
	}

	return <span className={`text-xs text-red-500 flex justify-start mt-1 ${className}`}>{error}</span>;
}
